document.addEventListener("wheel", function(event){
    if(event.target.type === "number" &&
        event.target.classList.contains("noscroll"))
    {
        event.target.blur();
    }
});